import {LitElement, css, html} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('dttb-heading')
export class DTTBHeading extends LitElement {

    @property()
    date: string;

    static styles = css`
      :host {
        margin-top: 16px;
        display: flex;
        flex-direction: row;
      }

      .green {
        font-weight: normal;
        background: var(--app-primary-color);
        color: white;
        padding: 0 6px;
        font-size: 1.17em;
      }

      .black {
        font-weight: normal;
        background: black;
        color: white;
        padding: 0 6px;
        font-size: 1.17em;
      }
    `;

    render() {
        return html`
            <div class="green">${this.weekdayPart()}</div>
            <div class="black">${this.datePart()}</div>
        `;
    }

    weekdayPart() {
        return this.date?.split(",")[0].trim() ?? "";
    }

    datePart() {
        return this.date?.split(",")[1].trim() ?? "";
    }

}